module.exports = __webpack_public_path__ + "img/pn.b92c8225.svg";